import type { IExtractParams } from "@/routes";
import { generatePath } from "@/routes/utils";

const pathBase = `/courses/:courseId/sessions/`;
const pathById = `${pathBase}:sessionId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const sessions = {
  getAll: (param: IPathBaseParam) => generatePath(pathBase, param),
  get: (param: IPathByIdParam) => generatePath(pathById, param),
} as const;
